export const SEARCH_QUERY_PARAM = 'q';
export const SEARCH_DEBOUNCE_MS = 300;
